
<div
  :class="
    classes(
      n(),
    )
  "
  role="radiogroup"
>
  <!-- 使用 options 渲染 -->
  <template v-if="options && options.length">
    <Radio
      v-for="(option, index) in normalizedOptions"
      :key="index"
      :value="getOptionValue(option)"
      :label="getOptionLabel(option)"
      :disabled="disabled || getOptionDisabled(option)"
      :checked="innerValue === getOptionValue(option)"
      :allow-uncheck="allowUncheck"
      :margin-less="marginLess"
      @change="handleRadioChange"
    />
  </template>
  <!-- 使用 slot 渲染 -->
  <template v-else>
    <slot />
  </template>
</div>
